/**
 * Sayfa degisiklik imzalari.
 *
 * sh (structural hash): meta + JSON-LD ozeti. Fiyat/stok gibi yapisal veriler
 *   burada degistiginde sunucu kaydi AI'siz, ucretsiz guncellenir.
 * ch (content hash): metin icerigi. Sayac/tarih/fiyat oynamalari yeniden analiz
 *   tetiklemesin diye rakamlar sifirlanir ve bosluklar sikistirilir.
 */

import { cyrb53 } from "./pageKey";

/** sh: yapisal alanlarin imzasi. */
export function structuralHash(meta, jsonLd) {
    const source = meta || {};
    const parts = [
        source.title || "",
        source.description || "",
        source.canonical || "",
        source.ogImage || "",
        source.ogType || "",
        source.favicon || "",
        source.h1 || "",
        (source.ldTypes || []).join(","),
        JSON.stringify(jsonLd || []),
    ];
    return cyrb53(parts.join(" "));
}

/** ch: icerigin sayilardan ve bosluklardan arindirilmis imzasi. */
export function contentHash(markdown) {
    const normalized = String(markdown || "")
        .toLowerCase()
        .replace(/\d/g, "0")
        .replace(/\s+/g, " ")
        .trim();
    return cyrb53(normalized);
}

export default { structuralHash, contentHash };



//////////////////
// WEBPACK FOOTER
// ./static/src/tracker/pages/hash.js
// module id = null
// module chunks = 